var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt_delete",
    transform: "translate(-910 -352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2134",
    "data-name": "Rectangle 2134",
    width: 33,
    height: 33,
    rx: 3,
    transform: "translate(910 352)",
    fill: "#fc0d1b",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(773.777 128.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-751.425-3709.388h-10.749a1.061,1.061,0,0,1-.75-1.106c-.106-1.762-.231-3.552-.351-5.284q-.067-.969-.134-1.935-.088-1.288-.176-2.575l-.007-.1-.008-.11q-.088-1.284-.175-2.569c0-.041,0-.081,0-.128,0-.024,0-.048,0-.073h14.028c0,.023,0,.046,0,.069,0,.049,0,.1,0,.152q-.064.879-.129,1.758l-.021.284q-.06.818-.12,1.636-.065.9-.13,1.792l-.023.317q-.055.754-.109,1.508-.067.918-.134,1.836l0,.04q-.067.911-.134,1.823c-.012.163-.025.326-.038.489-.031.385-.063.779-.077,1.167a.985.985,0,0,1-.759,1.01Zm-7.446-12.005h-.033a.58.58,0,0,0-.227.061.613.613,0,0,0-.341.6q0,1.019,0,2.039v3.4q0,.848,0,1.7v1.02a.606.606,0,0,0,.6.662.613.613,0,0,0,.6-.687q0-1.014,0-2.029,0-1.671,0-3.342v-2.8a.752.752,0,0,0,0-.089l0-.015a.607.607,0,0,0-.552-.523Zm4.224,0h-.028l-.039,0a.588.588,0,0,0-.532.639q0,1.288,0,2.577,0,.761,0,1.521,0,.677,0,1.353v1.394c0,.56,0,.989,0,1.393a.585.585,0,0,0,.576.6h.019a.6.6,0,0,0,.143-.017.606.606,0,0,0,.454-.546.987.987,0,0,0,0-.1v-8.149c0-.013,0-.026,0-.04,0-.029,0-.051,0-.072A.6.6,0,0,0-754.647-3721.389Z",
    transform: "translate(909.58 3960.117)",
    fill: "#fc0d1b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9967",
    "data-name": "Path 9967",
    d: "M144.44,290.918c0-.511-.039-1.012.009-1.5a1.306,1.306,0,0,1,1.289-1.176c.034,0,.068,0,.1,0q6.982,0,13.964,0a1.334,1.334,0,0,1,1.36,1,2.936,2.936,0,0,1,.055.63c.008.347,0,.694,0,1.053Z",
    transform: "translate(0 -55.3)",
    fill: "#fc0d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9968",
    "data-name": "Path 9968",
    d: "M240.969,231.729h-6.962c0-.121,0-.235,0-.349,0-.349,0-.7,0-1.046a.574.574,0,0,1,.587-.6c.048,0,.1,0,.144,0h5.517c.516,0,.722.2.723.716q0,.543,0,1.087C240.977,231.6,240.972,231.663,240.969,231.729Z",
    transform: "translate(-84.671 0)",
    fill: "#fc0d1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.44019478a9d1e9f7039d478afc1544b0.svg";
export { ForwardRef as ReactComponent };